import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { travelTicketRepository } from '../data-access/repositories/TravelTicketRepository'

const base = ['travel-ticket']

export const travelTicketQueryConfig = {
  listAttachable: (userId: number) => ({
    queryKey: buildQueryKey([...base, 'attachable', userId]),
    queryFn: () => travelTicketRepository.listAttachable(userId),
  }),
}
